import {
    FormControl,
    FormControls,
    IterateOptions
} from '../../../../../components/FormUtilities'
import InputField from '../../../../../components/InputField'
import NumeralField from '../../../../../components/NumeralField'
import SelectTouch from '../../../../../components/SelectTouch'
import Agent from '../../../../../models/Agent'
import { formCostGeneral } from '../storageStep3'

interface Fields3Props {
    type: 'national' | 'international'
}

export default function Fields3({ type }: Fields3Props) {
    return (
        <FormControls className="mb-4">
            <AgentField />
            <DocumentNumberField />
            {type === 'international' && <IvaField />}
        </FormControls>
    )
}

function DocumentNumberField() {
    const { props } = formCostGeneral.useInput('document_number')

    return (
        <FormControl label="Nro. de documento">
            <InputField {...props} placeholder="Ingresar número de documento" />
        </FormControl>
    )
}

function AgentField() {
    const { props, data } = formCostGeneral.useSelect<Agent>(
        'agent',
        '/v5.6/apis/agents?is_enabled=true'
    )
    return (
        <FormControl label="Agente">
            <SelectTouch {...props} placeholder="Seleccionar agente">
                <IterateOptions data={data} label="name" />
            </SelectTouch>
        </FormControl>
    )
}

function IvaField() {
    const { props } = formCostGeneral.useInput('iva')

    return (
        <FormControl label="IVA">
            <NumeralField {...props} decimal={2} placeholder="0.00" />
        </FormControl>
    )
}
